import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    // Restore tab from URL fragment
    const hash = window.location.hash.replace("#", "")
    if (hash) {
      const tab = this.tabTargets.find(t => t.id === `tab-${hash}`)
      if (tab) this.activate(tab)
    }
  }

  select(event) {
    this.activate(event.currentTarget)
  }

  keydown(event) {
    const tabs = this.tabTargets
    const current = tabs.indexOf(event.currentTarget)

    let next
    if (event.key === "ArrowRight") next = (current + 1) % tabs.length
    else if (event.key === "ArrowLeft") next = (current - 1 + tabs.length) % tabs.length
    else if (event.key === "Home") next = 0
    else if (event.key === "End") next = tabs.length - 1
    else return

    event.preventDefault()
    this.activate(tabs[next])
    tabs[next].focus()
  }

  activate(tab) {
    // Deactivate all
    this.tabTargets.forEach(t => {
      t.setAttribute("aria-selected", "false")
      t.setAttribute("tabindex", "-1")
    })
    this.panelTargets.forEach(p => p.hidden = true)

    // Activate selected
    tab.setAttribute("aria-selected", "true")
    tab.setAttribute("tabindex", "0")

    const panelId = tab.getAttribute("aria-controls")
    const panel = document.getElementById(panelId)
    if (panel) panel.hidden = false

    // Update URL fragment
    const tabName = tab.id.replace("tab-", "")
    history.replaceState(null, "", `#${tabName}`)
  }
}
